
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { Controlador as Model, ControladorInterfaz } from './controlador';
    import item from './facturacion-item.vue';
    import { Pedido } from '@/__env/lib/Ventas/Pedidos';
    import { Utiles } from '@/__env/pluggins/event-bus';
    @Component( {
        name: "Componente",
        props: {},
        components: {
            item,

        }
    } )
    export default class Componente extends Vue
    {
        constructor()
        {
            super();
            this.Controlador = new ControladorInterfaz();
        }

        public Controlador: ControladorInterfaz = null;
        public get Vista() { return this.Controlador.Vista; }

        @Prop()
        public Pedidos: Pedido[];

        @Prop()
        public Abrir: boolean;
        @Watch( 'Abrir' )
        async onAbrir()
        {
            this.Controlador.Reiniciar();
            this.Abierto = true;
            console.log( this.Controlador.Operaciones.length );
            if ( this.Pedidos && this.Pedidos.hasRows() )
            {
                await this.Controlador.Iniciar( this.Pedidos );
                //this.$nextTick( () =>  );
            }
            this.Pedidos.clear();
        }

        public Abierto: boolean = false;


        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );
        }

        async DescargarFacturas()
        {  //this.Cargando = true;
            let pdf = await Pedido.URLFacturas( this.Controlador.Operaciones.map( x => x.Pedido ) );
            if ( pdf )
            {
                window.open( pdf );
            } else
            {
                Utiles.Notificaciones.Error( `Error al descargar la factura` );

            }
            //this.Cargando = false;

        }

        async Iniciar()
        {
            if ( this.Controlador.Disponibles.length != this.Controlador.Operaciones.length )
            {
                let e = await Utiles.Mensajes.SiNoCancelar( 'Facturar ventas', `Solo se facturarán ${this.Controlador.Disponibles.length} ventas de un total de ${this.Controlador.Operaciones.length}. ¿Continuar de todos modos?` );
                if ( e == 's' )
                {
                    this.Controlador.Operaciones = this.Controlador.Operaciones.filter( x => x.Estado == 'en-espera' );
                    this.$nextTick( () =>
                    {
                        this.Controlador.Ejecutar();
                    } );
                }
                else if ( e == 'c' )
                {
                    this.Cerrar();
                }

            } else
            {
                this.Controlador.Ejecutar();
            }
        }

        public Refresh: boolean = true;
        public Refrescar()
        {
            this.Refresh = false;
            this.$nextTick( () => this.Refresh = true );
        }

        public Cerrar()
        {
            this.Controlador.Reiniciar();
            this.$emit( 'actualizar' );
            this.Abierto = false;
        }
    }
